import AutomFlow from './AutomFlow/AutomFlow';
import Start from './Start/Start';
import End from './End/End';
import If from '../Condition/If/If'
import { types } from './types';
import ProcessFlow from "./ProcessFlow/ProcessFlow";

function Actions(action, showAlert, variables, setOpenVariable, findElementName, getAutomNamesIDs) {
    switch (action.actionName) {
        case types.AUTOMFLOW: return <AutomFlow action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable} findElementName={findElementName} getAutomNamesIDs={getAutomNamesIDs}/>;
        case types.START: return <Start action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable}/>;
        case types.END: return <End action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable}/>;
        case types.IF: return <If action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable} process/>;
        case types.PROCESSFLOW: return <ProcessFlow action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable} findElementName={findElementName} getAutomNamesIDs={getAutomNamesIDs}/>;

        default: break;
    }
}

export default Actions;
